import type {
  insuranceCoverageApiSpec,
  insuranceMonitorApiSpec
} from "@wingspanhq/wingspan-api-types";

import intersection from "lodash/intersection";
import { selectorPolicyTypesFromSettings } from "./selectorPolicyTypesFromSettings";

type InsuranceCoverageMonitorSettings =
  insuranceMonitorApiSpec.InsuranceCoverageMonitorSettings;
type IPolicyType = insuranceCoverageApiSpec.InsuranceCoverage["policyType"];

export const selectorIsPolicyTypesMatched = (
  insuranceCoverageMonitorSettings?: InsuranceCoverageMonitorSettings,
  policyTypes?: IPolicyType[]
) => {
  const settingsTypes = selectorPolicyTypesFromSettings(
    insuranceCoverageMonitorSettings
  );

  return intersection(settingsTypes, policyTypes).length > 0;
};
